import { Tooltip } from '../../smartpak/tooltip';

export default async function addCapsLockListeners($inputs) {
    if ('nodeName' in $inputs) {
        monitorForCapsLock($inputs);
        return;
    }

    if ($inputs.length) {
        [...$inputs].forEach($input => monitorForCapsLock($input));
    }
}

function monitorForCapsLock($input) {
    if ($input.nodeName !== 'INPUT') {
        throw new Error('monitorForCapsLock expects an input element reference as an argument.');
    }

    const tooltip = new Tooltip($input, {
        trigger: 'Manual',
        content: 'Caps Lock is on.',
        showOnFocus: false
    });

    $input.addEventListener('keydown', e => {
        if (e.getModifierState && e.getModifierState('CapsLock')) {
            tooltip.show();
            return;
        }

        tooltip.hide();
    });

    $input.addEventListener('blur', tooltip.hide());
}